/**
 * Created by Ning Jiang on 6/13/2017.
 */

import {BetWayWinIndividualWPController} from "@nolimitcity/slot-game/bin/game/winpresentation/individualwin/BetWayWinIndividualWPController";
import {IIndividualWinPresentationConfig} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {WixxReelSymbol} from "../../reelsymbol/WixxReelSymbol";
import {WixxParsedGameData} from "../../server/data/WixxParsedGameData";
import {WixxHelper} from "../../utils/WixxHelper";
import {ReelSymbolName} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";
import {Timeline} from "gsap";

export class WixxIndividualWPController extends BetWayWinIndividualWPController {

    private _wixxGameData:WixxParsedGameData;

    constructor(config:IIndividualWinPresentationConfig) {
        super(config);
    }

    protected parseFeatureGameData(data:WixxParsedGameData):void {
        if(super.parseFeatureGameData) {
            super.parseFeatureGameData(data);
        }

        this._wixxGameData = data;
    }

    protected addSymbolWinAnimationToTimeline(betWayWinData:IBetWayWinData, timeline:Timeline, startTime:number, symbol:WixxReelSymbol, reelId:number, symbolId:number):void {
        super.addSymbolWinAnimationToTimeline(betWayWinData, timeline, startTime, symbol, reelId, symbolId);

        if(this._wixxGameData.multiplierRespinActive) {
            if((this._wixxGameData.symbolToWildRespinActive && symbol.symName.indexOf("M1") > -1) || symbol.symName === ReelSymbolName.WILD) {
                if(WixxHelper.isMidSymbol(betWayWinData.symbol)) {
                    timeline.add(symbol.playMultiplier(), startTime);
                } else {
                    timeline.add(() => symbol.hideMultiplier(0), startTime);
                }
            }
        }
    }
}